import React, { useEffect, createElement } from 'react';
import { UrgencyBar } from '../components/UrgencyBar';
import { HeroSection } from '../components/HeroSection';
import { PainSection } from '../components/PainSection';
import { RevelationSection } from '../components/RevelationSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { OfferSection } from '../components/OfferSection';
import { PricingSection } from '../components/PricingSection';
import { FAQSection } from '../components/FAQSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { ClosingSection } from '../components/ClosingSection';
import { Footer } from '../components/Footer';
export function LandingPage() {
  useEffect(() => {
    // Meta Pixel initialization
    if (!(window as any).fbq) {
      const n = ((window as any).fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      }) as any;
      if (!(window as any)._fbq) (window as any)._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(t);
    }
    ;
    (window as any).fbq('init', '1583309636230630');
    (window as any).fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-[#0a0e1a] text-[#f5f5f5] font-sans selection:bg-[#c9a84c]/30 selection:text-white" data-id="element-402">
      <UrgencyBar data-id="element-403" />
      <main data-id="element-404">
        <HeroSection data-id="element-405" />
        <PainSection data-id="element-406" />
        <RevelationSection data-id="element-407" />
        <TestimonialsSection data-id="element-408" />
        <OfferSection data-id="element-409" />
        <PricingSection data-id="element-410" />
        <FAQSection data-id="element-411" />
        <GuaranteeSection data-id="element-412" />
        <ClosingSection data-id="element-413" />
      </main>
      <Footer data-id="element-414" />
    </div>;
}